export const ru = {
    all: 'За любой период',
    'all-interest': 'Интересы за любой период',
    audience: 'Аудитория',
    'audience-and-metrika': 'Яндекс.Аудитории и Яндекс.Метрика',
    'audience-description':
        'Вы можете комбинировать различные условия - например учитывать интересы пользователя, уровень дохода, семейное положение, посещение заданных местоположений.',
    'audience-name': 'Название аудитории',
    'condition-rules-group-preview': {
        one: '{count} набор правил',
        some: '{count} набора правил',
        many: '{count} наборов правил',
        none: '{count} наборов правил'
    },
    'condition-rules-rule-preview': {
        one: '{count} правило',
        some: '{count} правила',
        many: '{count} правил',
        none: '{count} правил'
    },
    'description-by-day': {
        one: '{description} (за {count} день)',
        some: '{description} (за {count} дня)',
        many: '{description} (за {count} дней)',
        none: '{description} (за {count} дней)'
    },
    'interests-set': 'Набор интересов',
    isNotSet: 'не заданы',
    'long-term-interest': 'Долгосрочные интересы',
    long_term: 'Долгосрочные',
    'no-value-description': 'Не задана',
    'short-term-interest': 'Краткосрочные интересы',
    short_term: 'Краткосрочные',
    'unavailable-goal': 'Цель не найдена',
    'user-profile': 'Профиль пользователя',
    'user-profile-interests-description':
        'Вы можете задать три набора краткосрочных интересов пользователя, чтобы показать объявления только заинтересованным пользователям',
    'user-profile-name': 'Название профиля',
    'user-profile-no-value-description': 'Не задан'
};
